import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "title", "description", "actionText", "actionOnClick", "columnDefs", "rowData", "actions", "loading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import SectionList from "../../../../../components/SectionList";
import { Header } from "../../../components";
import { ActionLink } from "../";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Table');
const Table = _ref => {
  let {
      className,
      title,
      description,
      actionText,
      actionOnClick,
      columnDefs,
      rowData,
      actions,
      loading
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const headerProps = useMemo(() => ({
    title,
    description,
    className: classes.header
  }), [classes.header, description, title]);
  const sectionListProps = useMemo(() => _objectSpread({
    className: classes.sectionList,
    columnDefs,
    rowData,
    headerHeight: 40,
    rowHeight: 40,
    domLayout: 'autoHeight',
    actions,
    useLoaderPlaceholder: true,
    isLoading: loading
  }, otherProps), [otherProps, classes.sectionList, columnDefs, rowData, actions, loading]);
  const actionLinkProps = useMemo(() => ({
    text: actionText,
    className: classes.action,
    isDisabled: loading,
    onClick: actionOnClick
  }), [actionOnClick, actionText, classes.action, loading]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, {
      [classes.loading]: loading,
      className
    })
  }, /*#__PURE__*/React.createElement(Header, headerProps), /*#__PURE__*/React.createElement(SectionList, sectionListProps), /*#__PURE__*/React.createElement(ActionLink, actionLinkProps));
};
export default /*#__PURE__*/memo(Table);